<template>
	<div class="page">
		<!-- your page -->
		<div class="box">
			<div class="title">
				<div class="id">序号</div>
				<div class="name">名称</div>
				<div class="number">积分变动</div>
				<div class="time">变动时间</div>
				<div class="balance">剩余积分</div>
			</div>
			<div class="line" v-for="item in list">
				<div class="id">{{item.id}}</div>
				<div class="name">{{item.name}}</div>
				<div class="number">{{item.number}}</div>
				<div class="time">{{item.time}}</div>
				<div class="balance">{{item.balance}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'record',
		data(){
			return {
				list:[]
			}
		},
		methods:{
			fetchData(){
				var data = {
					"method":"IntegralFlow.positionIntegralsFlow",
					"pds":this.token
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						var reList = res.data
						for (var i = 0; i < reList.length; i++) {
							var obj = {
								name:reList[i].type_name,
								number:reList[i].num,
								balance:reList[i].balance,
								time:reList[i].ctime,
								id:reList[i].id
							}
							that.list.push(obj)
						}
					}else{
						that.globalTest('IntegralFlow.positionIntegraslShop','error',res.msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.token = localStorage.getItem('token')
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.box{
		width: 90%;
		margin: 0 auto;
		margin-top: 20px;
		font-size: 0px;
		letter-spacing: -6px;
		background: #d9f6ff;
	}
	.id,.name,.number,.time,.balance{
		display: inline-block;
		vertical-align: top;
		letter-spacing: normal;
		font-size:14px;
		height: 100%;
		border-right: 1px solid #C3C3C3;
		box-sizing: border-box;
	}
	.line,.title{
		width: 100%;
		height: 50px;
		text-align: center;
		line-height: 50px;
		border-bottom: 1px solid #C3C3C3;
	}
	.id{
		width: 13%;
	}
	.name{
		width: 20%;
		background: #e9faff;
	}
	.number{
		width: 25%;
	}
	.time{
		width: 17%;
		background: #e9faff;
	}
	.balance{
		width: 25%;
	}
</style>
